var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerks4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67.002,
    viewBox: "0 0 67 67.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "speedometer",
    transform: "translate(0.003 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5493",
    "data-name": "Pfad 5493",
    d: "M27.121,2a2.092,2.092,0,0,1,2.093,2.091v6.274a2.093,2.093,0,0,1-4.187,0V4.091A2.092,2.092,0,0,1,27.121,2ZM9.252,9.244a2.1,2.1,0,0,1,2.96,0l3.831,3.823a2.095,2.095,0,1,1-2.964,2.961L9.252,12.2a2.09,2.09,0,0,1,0-2.957ZM2,27.1A2.092,2.092,0,0,1,4.093,25h6.64a2.091,2.091,0,1,1,0,4.183H4.093A2.092,2.092,0,0,1,2,27.1Zm39.775,0A2.092,2.092,0,0,1,43.868,25h6.28a2.091,2.091,0,1,1,0,4.183h-6.28A2.092,2.092,0,0,1,41.775,27.1ZM44.932,9.336a1.63,1.63,0,0,0-2.206-.084l-17.5,14.957a3.808,3.808,0,1,0,5.455,5.266L45.057,11.5a1.626,1.626,0,0,0-.121-2.167Z",
    transform: "translate(6.375 6.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5494",
    "data-name": "Pfad 5494",
    d: "M27.9,66.519A33.494,33.494,0,1,1,66.521,39.09,33.494,33.494,0,0,1,27.9,66.519ZM8.377,48.591a50.291,50.291,0,0,1,50.237,0,29.3,29.3,0,1,0-50.237,0Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerks4);
export default __webpack_public_path__ + "static/media/perks4.b1a19df1eed18de6026437684164559f.svg";
export { ForwardRef as ReactComponent };